const translations = {
    'founding.title': 'Found Settlement',
    'founding.alreadySettled': 'This region already has a settlement.',
    'founding.notControlled': 'You do not control this region.',
    'founding.inProgress': 'A founding expedition is already on the way.',
    'founding.noPopulation': 'No settlement has enough free population.',
    'founding.destination': 'Destination',
    'founding.tile': 'Tile: %s',
    'founding.distance': 'Distance: %d',
    'founding.source': 'From: %s',
    'founding.population': 'Settlers',
    'founding.populationRequired': 'Required: %d',
    'founding.populationFree': 'Free population: %d',
    'founding.escort': 'Escort',
    'founding.escortSelected': 'Militia: %d/%d',
    'founding.unitPlus': '+1',
    'founding.unitMinus': '-1',
    'founding.food': 'Supplies',
    'founding.foodAvailable': 'Food available: %d',
    'founding.foodSelected': 'Food selected: %d',
    'founding.foodSuggested': 'Suggested: %d',
    'founding.foodPlus': '+ food',
    'founding.foodMinus': '- food',
    'founding.supplies': 'Cargo',
    'founding.toolsRequired': 'Tools required: %d',
    'founding.resourceLine': '%s: %d/%d',
    'founding.resourcePlus': '+',
    'founding.resourceMinus': '-',
    'founding.launch': 'Launch',
    'founding.send': 'Send expedition',
};

export default translations;
